import ActionTile from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/ActionTile'
import { ZohoLogo } from '@/containers/SubscriptionFormPageNew/Components/Tools/styled-components'
import useZohoButton from './useZohoButton'
import logo from '../../ZohoId/logo.svg'

const ZohoButton = () => {
  const { t, zohoContractId } = useZohoButton()

  if (!zohoContractId) {
    return null
  }

  return (
    <ActionTile
      href={`https://crm.zoho.com/crm/org52021474/tab/CustomModule5/${zohoContractId}`}
      label={t('subscriptionForm:zoho_module.link_zoho')}
      icon={<ZohoLogo src={logo} alt='Zoho Logo' />}
    />
  )
}

export default ZohoButton
